module.exports = __webpack_public_path__ + "static/media/spades-queen.29772362.png";